export const convertRemToPixels = (rem: number) =>
  rem * parseFloat(getComputedStyle(document.documentElement).fontSize);

export const convertCurrencyCodeToSymbol = (currencyCode: string) =>
  Intl.NumberFormat("en", { style: "currency", currency: currencyCode })
    .formatToParts()
    .find((part) => part.type === "currency")?.value;
